import { createReducer, createAction } from "redux-act";
import * as app from "./app";
import { message } from "antd";
import { pendingTask, begin, end } from "react-redux-spinner";
import merge from "lodash/merge";
import remove from "lodash/remove";
import { logout } from "./app";
import {
  IMPORT_FORM_SUCCESS_ACTION,
  IMPORT_FORM_REQUEST_ACTION,
  IMPORT_FORM_FAILURE_ACTION
} from "./import";

import {
  SAVE_PATIENT_SUCCESS_ACTION,
  LOAD_PATIENT_REQUEST_ACTION,
  LOAD_PATIENT_SUCCESS_ACTION,
  LOAD_PATIENT_FAILURE_ACTION,
  DELETE_PATIENT_SUCCESS_ACTION,
  SAVE_PATIENT_CONDITION_SUCCESS_ACTION,
  DELETE_PATIENT_CONDITION_SUCCESS_ACTION
} from "./patient";

export const REDUCER = "data";

export const NS = `@@${REDUCER}/`;

/*********************************/
/*     LOGIN_SUCCESS     */
/*********************************/
const LOGIN_REQUEST = `${NS}login_request`;
export const LOGIN_REQUEST_ACTION = createAction(LOGIN_REQUEST);
const LOGIN_SUCCESS = `${NS}login_success`;
export const LOGIN_SUCCESS_ACTION = createAction(LOGIN_SUCCESS, accounts => ({
  accounts
}));
const LOGIN_FAILURE = `${NS}login_failure`;
export const LOGIN_FAILURE_ACTION = createAction(LOGIN_FAILURE);

export const loginRequest = searchTerm => {
  const action = LOGIN_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loginSuccess = user => {
  const action = LOGIN_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const loginFailure = error => {
  const action = LOGIN_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     RESET_PASSWORD_SUCCESS     */
/*********************************/
const RESET_PASSWORD_REQUEST = `${app.NS}resetPassword_request`;
export const RESET_PASSWORD_REQUEST_ACTION = createAction(
  RESET_PASSWORD_REQUEST
);
const RESET_PASSWORD_SUCCESS = `${app.NS}resetPassword_success`;
export const RESET_PASSWORD_SUCCESS_ACTION = createAction(
  RESET_PASSWORD_SUCCESS,
  accounts => ({
    accounts
  })
);
const RESET_PASSWORD_FAILURE = `${app.NS}resetPassword_failure`;
export const RESET_PASSWORD_FAILURE_ACTION = createAction(
  RESET_PASSWORD_FAILURE
);

export const resetPasswordRequest = searchTerm => {
  const action = RESET_PASSWORD_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const resetPasswordSuccess = user => {
  const action = RESET_PASSWORD_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const resetPasswordFailure = error => {
  const action = RESET_PASSWORD_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     DOWNLOAD_FILE_SUCCESS     */
/*********************************/
const DOWNLOAD_FILE_REQUEST = `${app.NS}downloadFile_request`;
export const DOWNLOAD_FILE_REQUEST_ACTION = createAction(DOWNLOAD_FILE_REQUEST);
const DOWNLOAD_FILE_SUCCESS = `${app.NS}downloadFile_success`;
export const DOWNLOAD_FILE_SUCCESS_ACTION = createAction(
  DOWNLOAD_FILE_SUCCESS,
  accounts => ({
    accounts
  })
);
const DOWNLOAD_FILE_FAILURE = `${app.NS}downloadFile_failure`;
export const DOWNLOAD_FILE_FAILURE_ACTION = createAction(DOWNLOAD_FILE_FAILURE);

export const downloadFileRequest = searchTerm => {
  const action = DOWNLOAD_FILE_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const downloadFileSuccess = user => {
  const action = DOWNLOAD_FILE_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const downloadFileFailure = error => {
  const action = DOWNLOAD_FILE_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     FORGOT_PASSWORD_SUCCESS     */
/*********************************/
const FORGOT_PASSWORD_REQUEST = `${NS}forgotPassword_request`;
export const FORGOT_PASSWORD_REQUEST_ACTION = createAction(
  FORGOT_PASSWORD_REQUEST
);
const FORGOT_PASSWORD_SUCCESS = `${NS}forgotPassword_success`;
export const FORGOT_PASSWORD_SUCCESS_ACTION = createAction(
  FORGOT_PASSWORD_SUCCESS,
  accounts => ({
    accounts
  })
);
const FORGOT_PASSWORD_FAILURE = `${NS}forgotPassword_failure`;
export const FORGOT_PASSWORD_FAILURE_ACTION = createAction(
  FORGOT_PASSWORD_FAILURE
);

export const forgotPasswordRequest = searchTerm => {
  const action = FORGOT_PASSWORD_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const forgotPasswordSuccess = user => {
  const action = FORGOT_PASSWORD_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const forgotPasswordFailure = error => {
  const action = FORGOT_PASSWORD_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOGOUT_SUCCESS     */
/*********************************/
const LOGOUT_REQUEST = `${NS}logout_request`;
export const LOGOUT_REQUEST_ACTION = createAction(LOGOUT_REQUEST);
const LOGOUT_SUCCESS = `${NS}logout_success`;
export const LOGOUT_SUCCESS_ACTION = createAction(LOGOUT_SUCCESS, accounts => ({
  accounts
}));
const LOGOUT_FAILURE = `${NS}logout_failure`;
export const LOGOUT_FAILURE_ACTION = createAction(LOGOUT_FAILURE);

export const logoutRequest = () => {
  const action = LOGOUT_REQUEST_ACTION();
  action[pendingTask] = begin;
  return action;
};
export const logoutSuccess = user => {
  const action = LOGOUT_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const logoutFailure = error => {
  const action = LOGOUT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_ACCOUNTS_REQUEST     */
/*********************************/

const LOAD_ACCOUNTS_REQUEST = `${NS}load_accounts_request`;
export const LOAD_ACCOUNTS_REQUEST_ACTION = createAction(LOAD_ACCOUNTS_REQUEST);
const LOAD_ACCOUNTS_SUCCESS = `${NS}load_accounts_success`;
export const LOAD_ACCOUNTS_SUCCESS_ACTION = createAction(
  LOAD_ACCOUNTS_SUCCESS,
  accounts => ({
    accounts
  })
);
const LOAD_ACCOUNTS_FAILURE = `${NS}load_accounts_failure`;
export const LOAD_ACCOUNTS_FAILURE_ACTION = createAction(LOAD_ACCOUNTS_FAILURE);

export const loadAccountsRequest = searchTerm => {
  const action = LOAD_ACCOUNTS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadAccountsSuccess = accounts => {
  const action = LOAD_ACCOUNTS_SUCCESS_ACTION(accounts);
  action[pendingTask] = end;
  return action;
};
export const loadAccountsFailure = error => {
  const action = LOAD_ACCOUNTS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_ACCOUNT_REQUEST      */
/*********************************/
const LOAD_ACCOUNT_REQUEST = `${NS}load_account_request`;
export const LOAD_ACCOUNT_REQUEST_ACTION = createAction(LOAD_ACCOUNT_REQUEST);
const LOAD_ACCOUNT_SUCCESS = `${NS}load_account_success`;
export const LOAD_ACCOUNT_SUCCESS_ACTION = createAction(
  LOAD_ACCOUNT_SUCCESS,
  account => ({
    account
  })
);
const LOAD_ACCOUNT_FAILURE = `${NS}load_account_failure`;
export const LOAD_ACCOUNT_FAILURE_ACTION = createAction(LOAD_ACCOUNT_FAILURE);

export const loadAccountRequest = id => {
  const action = LOAD_ACCOUNT_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadAccountSuccess = account => {
  const action = LOAD_ACCOUNT_SUCCESS_ACTION(account);
  action[pendingTask] = end;
  return action;
};
export const loadAccountFailure = error => {
  const action = LOAD_ACCOUNT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_ACTIVE_ACCOUNT_REQUEST      */
/*********************************/
const LOAD_ACTIVE_ACCOUNT_REQUEST = `${NS}load_account_request`;
export const LOAD_ACTIVE_ACCOUNT_REQUEST_ACTION = createAction(
  LOAD_ACTIVE_ACCOUNT_REQUEST
);
const LOAD_ACTIVE_ACCOUNT_SUCCESS = `${NS}load_account_success`;
export const LOAD_ACTIVE_ACCOUNT_SUCCESS_ACTION = createAction(
  LOAD_ACTIVE_ACCOUNT_SUCCESS,
  account => ({
    account
  })
);
const LOAD_ACTIVE_ACCOUNT_FAILURE = `${NS}load_account_failure`;
export const LOAD_ACTIVE_ACCOUNT_FAILURE_ACTION = createAction(
  LOAD_ACTIVE_ACCOUNT_FAILURE
);

export const loadActiveAccountRequest = id => {
  const action = LOAD_ACTIVE_ACCOUNT_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadActiveAccountSuccess = account => {
  const action = LOAD_ACTIVE_ACCOUNT_SUCCESS_ACTION(account);
  action[pendingTask] = end;
  return action;
};
export const loadActiveAccountFailure = error => {
  const action = LOAD_ACTIVE_ACCOUNT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SAVE_ACCOUNT_REQUEST  */
/*********************************/
const SAVE_ACCOUNT_REQUEST = `${NS}save_account_request`;
export const SAVE_ACCOUNT_REQUEST_ACTION = createAction(SAVE_ACCOUNT_REQUEST);
const SAVE_ACCOUNT_SUCCESS = `${NS}save_account_success`;

export const SAVE_ACCOUNT_SUCCESS_ACTION = createAction(
  SAVE_ACCOUNT_SUCCESS,
  account => ({
    account
  })
);
const SAVE_ACCOUNT_FAILURE = `${NS}save_account_failure`;
export const SAVE_ACCOUNT_FAILURE_ACTION = createAction(SAVE_ACCOUNT_FAILURE);

export const saveAccountRequest = id => {
  const action = SAVE_ACCOUNT_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const saveAccountSuccess = user => {
  const action = SAVE_ACCOUNT_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const saveAccountFailure = error => {
  const action = SAVE_ACCOUNT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_ACCOUNT_REQUEST  */
/*********************************/
const DELETE_ACCOUNT_REQUEST = `${NS}delete_account_request`;
export const DELETE_ACCOUNT_REQUEST_ACTION = createAction(
  DELETE_ACCOUNT_REQUEST
);
const DELETE_ACCOUNT_SUCCESS = `${NS}delete_account_success`;

export const DELETE_ACCOUNT_SUCCESS_ACTION = createAction(
  DELETE_ACCOUNT_SUCCESS,
  account => ({
    account
  })
);
const DELETE_ACCOUNT_FAILURE = `${NS}delete_account_failure`;
export const DELETE_ACCOUNT_FAILURE_ACTION = createAction(
  DELETE_ACCOUNT_FAILURE
);

export const deleteAccountRequest = id => {
  const action = DELETE_ACCOUNT_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteAccountSuccess = user => {
  const action = DELETE_ACCOUNT_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deleteAccountFailure = error => {
  const action = DELETE_ACCOUNT_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_DASHBOARD_REQUEST      */
/*********************************/
const LOAD_DASHBOARD_REQUEST = `${NS}load_dashboard_request`;
export const LOAD_DASHBOARD_REQUEST_ACTION = createAction(
  LOAD_DASHBOARD_REQUEST
);
const LOAD_DASHBOARD_SUCCESS = `${NS}load_dashboard_success`;
export const LOAD_DASHBOARD_SUCCESS_ACTION = createAction(
  LOAD_DASHBOARD_SUCCESS,
  dashboard => ({
    dashboard
  })
);
const LOAD_DASHBOARD_FAILURE = `${NS}load_dashboard_failure`;
export const LOAD_DASHBOARD_FAILURE_ACTION = createAction(
  LOAD_DASHBOARD_FAILURE
);

export const loadDashboardRequest = id => {
  const action = LOAD_DASHBOARD_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadDashboardSuccess = dashboard => {
  const action = LOAD_DASHBOARD_SUCCESS_ACTION(dashboard);
  action[pendingTask] = end;
  return action;
};
export const loadDashboardFailure = error => {
  const action = LOAD_DASHBOARD_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_USERS_REQUEST     */
/*********************************/

const LOAD_USERS_REQUEST = `${NS}load_users_request`;
export const LOAD_USERS_REQUEST_ACTION = createAction(LOAD_USERS_REQUEST);
const LOAD_USERS_SUCCESS = `${NS}load_users_success`;
export const LOAD_USERS_SUCCESS_ACTION = createAction(
  LOAD_USERS_SUCCESS,
  users => ({
    users
  })
);
const LOAD_USERS_FAILURE = `${NS}load_users_failure`;
export const LOAD_USERS_FAILURE_ACTION = createAction(LOAD_USERS_FAILURE);

export const loadUsersRequest = searchTerm => {
  const action = LOAD_USERS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadUsersSuccess = users => {
  const action = LOAD_USERS_SUCCESS_ACTION(users);
  action[pendingTask] = end;
  return action;
};
export const loadUsersFailure = error => {
  const action = LOAD_USERS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_CLINICIANS_REQUEST     */
/*********************************/

const LOAD_CLINICIANS_REQUEST = `${NS}load_clinicians_request`;
export const LOAD_CLINICIANS_REQUEST_ACTION = createAction(
  LOAD_CLINICIANS_REQUEST
);
const LOAD_CLINICIANS_SUCCESS = `${NS}load_clinicians_success`;
export const LOAD_CLINICIANS_SUCCESS_ACTION = createAction(
  LOAD_CLINICIANS_SUCCESS,
  clinicians => ({
    clinicians
  })
);
const LOAD_CLINICIANS_FAILURE = `${NS}load_clinicians_failure`;
export const LOAD_CLINICIANS_FAILURE_ACTION = createAction(
  LOAD_CLINICIANS_FAILURE
);

export const loadCliniciansRequest = searchTerm => {
  const action = LOAD_CLINICIANS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadCliniciansSuccess = clinicians => {
  const action = LOAD_CLINICIANS_SUCCESS_ACTION(clinicians);
  action[pendingTask] = end;
  return action;
};
export const loadCliniciansFailure = error => {
  const action = LOAD_CLINICIANS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_USER_REQUEST      */
/*********************************/
const LOAD_USER_REQUEST = `${NS}load_user_request`;
export const LOAD_USER_REQUEST_ACTION = createAction(LOAD_USER_REQUEST);
const LOAD_USER_SUCCESS = `${NS}load_user_success`;
export const LOAD_USER_SUCCESS_ACTION = createAction(
  LOAD_USER_SUCCESS,
  user => ({
    user
  })
);
const LOAD_USER_FAILURE = `${NS}load_user_failure`;
export const LOAD_USER_FAILURE_ACTION = createAction(LOAD_USER_FAILURE);

export const loadUserRequest = id => {
  const action = LOAD_USER_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadUserSuccess = user => {
  const action = LOAD_USER_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const loadUserFailure = error => {
  const action = LOAD_USER_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SAVE_USER_REQUEST  */
/*********************************/
const SAVE_USER_REQUEST = `${NS}save_user_request`;
export const SAVE_USER_REQUEST_ACTION = createAction(SAVE_USER_REQUEST);
const SAVE_USER_SUCCESS = `${NS}save_user_success`;

export const SAVE_USER_SUCCESS_ACTION = createAction(
  SAVE_USER_SUCCESS,
  user => ({
    user
  })
);
const SAVE_USER_FAILURE = `${NS}save_user_failure`;
export const SAVE_USER_FAILURE_ACTION = createAction(SAVE_USER_FAILURE);

export const saveUserRequest = id => {
  const action = SAVE_USER_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const saveUserSuccess = user => {
  const action = SAVE_USER_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const saveUserFailure = error => {
  const action = SAVE_USER_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_USER_REQUEST  */
/*********************************/
const DELETE_USER_REQUEST = `${NS}delete_user_request`;
export const DELETE_USER_REQUEST_ACTION = createAction(DELETE_USER_REQUEST);
const DELETE_USER_SUCCESS = `${NS}delete_user_success`;

export const DELETE_USER_SUCCESS_ACTION = createAction(
  DELETE_USER_SUCCESS,
  user => ({
    user
  })
);
const DELETE_USER_FAILURE = `${NS}delete_user_failure`;
export const DELETE_USER_FAILURE_ACTION = createAction(DELETE_USER_FAILURE);

export const deleteUserRequest = id => {
  const action = DELETE_USER_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteUserSuccess = user => {
  const action = DELETE_USER_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deleteUserFailure = error => {
  const action = DELETE_USER_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_LOCATIONS_REQUEST     */
/*********************************/

const LOAD_LOCATIONS_REQUEST = `${NS}load_locations_request`;
export const LOAD_LOCATIONS_REQUEST_ACTION = createAction(
  LOAD_LOCATIONS_REQUEST
);
const LOAD_LOCATIONS_SUCCESS = `${NS}load_locations_success`;
export const LOAD_LOCATIONS_SUCCESS_ACTION = createAction(
  LOAD_LOCATIONS_SUCCESS,
  locations => ({
    locations
  })
);
const LOAD_LOCATIONS_FAILURE = `${NS}load_locations_failure`;
export const LOAD_LOCATIONS_FAILURE_ACTION = createAction(
  LOAD_LOCATIONS_FAILURE
);

export const loadLocationsRequest = searchTerm => {
  const action = LOAD_LOCATIONS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadLocationsSuccess = locations => {
  const action = LOAD_LOCATIONS_SUCCESS_ACTION(locations);
  action[pendingTask] = end;
  return action;
};
export const loadLocationsFailure = error => {
  const action = LOAD_LOCATIONS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_LOCATION_REQUEST      */
/*********************************/
const LOAD_LOCATION_REQUEST = `${NS}load_location_request`;
export const LOAD_LOCATION_REQUEST_ACTION = createAction(LOAD_LOCATION_REQUEST);
const LOAD_LOCATION_SUCCESS = `${NS}load_location_success`;
export const LOAD_LOCATION_SUCCESS_ACTION = createAction(
  LOAD_LOCATION_SUCCESS,
  location => ({
    location
  })
);
const LOAD_LOCATION_FAILURE = `${NS}load_location_failure`;
export const LOAD_LOCATION_FAILURE_ACTION = createAction(LOAD_LOCATION_FAILURE);

export const loadLocationRequest = id => {
  const action = LOAD_LOCATION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadLocationSuccess = location => {
  const action = LOAD_LOCATION_SUCCESS_ACTION(location);
  action[pendingTask] = end;
  return action;
};
export const loadLocationFailure = error => {
  const action = LOAD_LOCATION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SAVE_LOCATION_REQUEST  */
/*********************************/
const SAVE_LOCATION_REQUEST = `${NS}save_location_request`;
export const SAVE_LOCATION_REQUEST_ACTION = createAction(SAVE_LOCATION_REQUEST);
const SAVE_LOCATION_SUCCESS = `${NS}save_location_success`;

export const SAVE_LOCATION_SUCCESS_ACTION = createAction(
  SAVE_LOCATION_SUCCESS,
  location => ({
    location
  })
);
const SAVE_LOCATION_FAILURE = `${NS}save_location_failure`;
export const SAVE_LOCATION_FAILURE_ACTION = createAction(SAVE_LOCATION_FAILURE);

export const saveLocationRequest = id => {
  const action = SAVE_LOCATION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const saveLocationSuccess = location => {
  const action = SAVE_LOCATION_SUCCESS_ACTION(location);
  action[pendingTask] = end;
  return action;
};
export const saveLocationFailure = error => {
  const action = SAVE_LOCATION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_LOCATION_REQUEST  */
/*********************************/
const DELETE_LOCATION_REQUEST = `${NS}delete_location_request`;
export const DELETE_LOCATION_REQUEST_ACTION = createAction(
  DELETE_LOCATION_REQUEST
);
const DELETE_LOCATION_SUCCESS = `${NS}delete_location_success`;

export const DELETE_LOCATION_SUCCESS_ACTION = createAction(
  DELETE_LOCATION_SUCCESS,
  location => ({
    location
  })
);
const DELETE_LOCATION_FAILURE = `${NS}delete_location_failure`;
export const DELETE_LOCATION_FAILURE_ACTION = createAction(
  DELETE_LOCATION_FAILURE
);

export const deleteLocationRequest = id => {
  const action = DELETE_LOCATION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteLocationSuccess = location => {
  const action = DELETE_LOCATION_SUCCESS_ACTION(location);
  action[pendingTask] = end;
  return action;
};
export const deleteLocationFailure = error => {
  const action = DELETE_LOCATION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_PATIENTS_REQUEST      */
/*********************************/
const LOAD_PATIENTS_REQUEST = `${NS}load_patients_request`;
export const LOAD_PATIENTS_REQUEST_ACTION = createAction(LOAD_PATIENTS_REQUEST);
const LOAD_PATIENTS_SUCCESS = `${NS}load_patients_success`;
export const LOAD_PATIENTS_SUCCESS_ACTION = createAction(
  LOAD_PATIENTS_SUCCESS,
  (searchTerm, patients) => ({
    searchTerm,
    patients
  })
);
const LOAD_PATIENTS_FAILURE = `${NS}load_patients_failure`;
export const LOAD_PATIENTS_FAILURE_ACTION = createAction(LOAD_PATIENTS_FAILURE);

export const loadPatientsRequest = searchTerm => {
  const action = LOAD_PATIENTS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadPatientsSuccess = (searchTerm, patients) => {
  const action = LOAD_PATIENTS_SUCCESS_ACTION(searchTerm, patients);
  action[pendingTask] = end;
  return action;
};
export const loadPatientsFailure = error => {
  const action = LOAD_PATIENTS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

// /*********************************/
// /*     LOAD_PATIENT_REQUEST      */
// /*********************************/
// const LOAD_PATIENT_REQUEST = `${NS}load_patient_request`;
// export const LOAD_PATIENT_REQUEST_ACTION = createAction(LOAD_PATIENT_REQUEST);
// const LOAD_PATIENT_SUCCESS = `${NS}load_patient_success`;
// export const LOAD_PATIENT_SUCCESS_ACTION = createAction(
//   LOAD_PATIENT_SUCCESS,
//   patient => ({
//     patient
//   })
// );
// const LOAD_PATIENT_FAILURE = `${NS}load_patient_failure`;
// export const LOAD_PATIENT_FAILURE_ACTION = createAction(LOAD_PATIENT_FAILURE);

// export const loadPatientRequest = id => {
//   const action = LOAD_PATIENT_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const loadPatientSuccess = patient => {
//   const action = LOAD_PATIENT_SUCCESS_ACTION(patient);
//   action[pendingTask] = end;
//   return action;
// };
// export const loadPatientFailure = error => {
//   const action = LOAD_PATIENT_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /* SEND_REMINDER_PATIENT_REQUEST */
// /*********************************/
// const SEND_REMINDER_PATIENT_REQUEST = `${NS}send_reminder_patient_request`;
// export const SEND_REMINDER_PATIENT_REQUEST_ACTION = createAction(
//   SEND_REMINDER_PATIENT_REQUEST
// );
// const SEND_REMINDER_PATIENT_SUCCESS = `${NS}send_reminder_patient_success`;
// export const SEND_REMINDER_PATIENT_SUCCESS_ACTION = createAction(
//   SEND_REMINDER_PATIENT_SUCCESS,
//   patient => ({
//     patient
//   })
// );
// const SEND_REMINDER_PATIENT_FAILURE = `${NS}send_reminder_patient_failure`;
// export const SEND_REMINDER_PATIENT_FAILURE_ACTION = createAction(
//   SEND_REMINDER_PATIENT_FAILURE
// );

// export const sendReminderPatientRequest = id => {
//   const action = SEND_REMINDER_PATIENT_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const sendReminderPatientSuccess = patient => {
//   const action = SEND_REMINDER_PATIENT_SUCCESS_ACTION(patient);
//   action[pendingTask] = end;
//   return action;
// };
// export const sendReminderPatientFailure = error => {
//   const action = SEND_REMINDER_PATIENT_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /* SEND_PUSH_NOTIFICATION_REQUEST */
// /*********************************/
// const SEND_PUSH_NOTIFICATION_REQUEST = `${NS}send_push_notification_request`;
// export const SEND_PUSH_NOTIFICATION_REQUEST_ACTION = createAction(
//   SEND_PUSH_NOTIFICATION_REQUEST
// );
// const SEND_PUSH_NOTIFICATION_SUCCESS = `${NS}send_push_notification_success`;
// export const SEND_PUSH_NOTIFICATION_SUCCESS_ACTION = createAction(
//   SEND_PUSH_NOTIFICATION_SUCCESS,
//   patient => ({
//     patient
//   })
// );
// const SEND_PUSH_NOTIFICATION_FAILURE = `${NS}send_push_notification_failure`;
// export const SEND_PUSH_NOTIFICATION_FAILURE_ACTION = createAction(
//   SEND_PUSH_NOTIFICATION_FAILURE
// );

// export const sendPushNotificationRequest = id => {
//   const action = SEND_PUSH_NOTIFICATION_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const sendPushNotificationSuccess = patient => {
//   const action = SEND_PUSH_NOTIFICATION_SUCCESS_ACTION(patient);
//   action[pendingTask] = end;
//   return action;
// };
// export const sendPushNotificationFailure = error => {
//   const action = SEND_PUSH_NOTIFICATION_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

/*********************************/
/* SEND_REMINDER_USER_REQUEST */
/*********************************/
const SEND_REMINDER_USER_REQUEST = `${NS}send_reminder_user_request`;
export const SEND_REMINDER_USER_REQUEST_ACTION = createAction(
  SEND_REMINDER_USER_REQUEST
);
const SEND_REMINDER_USER_SUCCESS = `${NS}send_reminder_user_success`;
export const SEND_REMINDER_USER_SUCCESS_ACTION = createAction(
  SEND_REMINDER_USER_SUCCESS,
  user => ({
    user
  })
);
const SEND_REMINDER_USER_FAILURE = `${NS}send_reminder_user_failure`;
export const SEND_REMINDER_USER_FAILURE_ACTION = createAction(
  SEND_REMINDER_USER_FAILURE
);

export const sendReminderUserRequest = id => {
  const action = SEND_REMINDER_USER_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const sendReminderUserSuccess = user => {
  const action = SEND_REMINDER_USER_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const sendReminderUserFailure = error => {
  const action = SEND_REMINDER_USER_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

// /*********************************/
// /* DELETE_GUEST_PERMISSION_REQUEST  */
// /*********************************/
// const DELETE_GUEST_PERMISSION_REQUEST = `${
//   app.NS
// }delete_guestPermission_request`;
// export const DELETE_GUEST_PERMISSION_REQUEST_ACTION = createAction(
//   DELETE_GUEST_PERMISSION_REQUEST
// );
// const DELETE_GUEST_PERMISSION_SUCCESS = `${
//   app.NS
// }delete_guestPermission_success`;

// export const DELETE_GUEST_PERMISSION_SUCCESS_ACTION = createAction(
//   DELETE_GUEST_PERMISSION_SUCCESS,
//   guestPermission => ({
//     guestPermission
//   })
// );
// const DELETE_GUEST_PERMISSION_FAILURE = `${
//   app.NS
// }delete_guestPermission_failure`;
// export const DELETE_GUEST_PERMISSION_FAILURE_ACTION = createAction(
//   DELETE_GUEST_PERMISSION_FAILURE
// );

// export const deleteGuestPermissionRequest = id => {
//   const action = DELETE_GUEST_PERMISSION_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const deleteGuestPermissionSuccess = user => {
//   const action = DELETE_GUEST_PERMISSION_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const deleteGuestPermissionFailure = error => {
//   const action = DELETE_GUEST_PERMISSION_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /*     SAVE_PATIENT_REQUEST      */
// /*********************************/
// const SAVE_PATIENT_REQUEST = `${NS}save_patient_request`;
// export const SAVE_PATIENT_REQUEST_ACTION = createAction(SAVE_PATIENT_REQUEST);
// const SAVE_PATIENT_SUCCESS = `${NS}save_patient_success`;
// export const SAVE_PATIENT_SUCCESS_ACTION = createAction(
//   SAVE_PATIENT_SUCCESS,
//   patients => ({
//     patients
//   })
// );
// const SAVE_PATIENT_FAILURE = `${NS}save_patient_failure`;
// export const SAVE_PATIENT_FAILURE_ACTION = createAction(SAVE_PATIENT_FAILURE);

// export const savePatientRequest = id => {
//   const action = SAVE_PATIENT_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const savePatientSuccess = user => {
//   const action = SAVE_PATIENT_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const savePatientFailure = error => {
//   const action = SAVE_PATIENT_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /* DELETE_PATIENT_REQUEST  */
// /*********************************/
// const DELETE_PATIENT_REQUEST = `${app.NS}delete_patient_request`;
// export const DELETE_PATIENT_REQUEST_ACTION = createAction(
//   DELETE_PATIENT_REQUEST
// );
// const DELETE_PATIENT_SUCCESS = `${app.NS}delete_patient_success`;

// export const DELETE_PATIENT_SUCCESS_ACTION = createAction(
//   DELETE_PATIENT_SUCCESS,
//   patient => ({
//     patient
//   })
// );
// const DELETE_PATIENT_FAILURE = `${app.NS}delete_patient_failure`;
// export const DELETE_PATIENT_FAILURE_ACTION = createAction(
//   DELETE_PATIENT_FAILURE
// );

// export const deletePatientRequest = id => {
//   const action = DELETE_PATIENT_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const deletePatientSuccess = user => {
//   const action = DELETE_PATIENT_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const deletePatientFailure = error => {
//   const action = DELETE_PATIENT_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /* DELETE_SUPPORT_USER_REQUEST  */
// /*********************************/
// const DELETE_SUPPORT_USER_REQUEST = `${app.NS}delete_supportUser_request`;
// export const DELETE_SUPPORT_USER_REQUEST_ACTION = createAction(
//   DELETE_SUPPORT_USER_REQUEST
// );
// const DELETE_SUPPORT_USER_SUCCESS = `${app.NS}delete_supportUser_success`;

// export const DELETE_SUPPORT_USER_SUCCESS_ACTION = createAction(
//   DELETE_SUPPORT_USER_SUCCESS,
//   supportUser => ({
//     supportUser
//   })
// );
// const DELETE_SUPPORT_USER_FAILURE = `${app.NS}delete_supportUser_failure`;
// export const DELETE_SUPPORT_USER_FAILURE_ACTION = createAction(
//   DELETE_SUPPORT_USER_FAILURE
// );

// export const deleteSupportUserRequest = id => {
//   const action = DELETE_SUPPORT_USER_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const deleteSupportUserSuccess = user => {
//   const action = DELETE_SUPPORT_USER_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const deleteSupportUserFailure = error => {
//   const action = DELETE_SUPPORT_USER_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /* SAVE_PATIENT_CONDITION_REQUEST  */
// /*********************************/
// const SAVE_PATIENT_CONDITION_REQUEST = `${
//   app.NS
// }save_patient_condition_request`;
// export const SAVE_PATIENT_CONDITION_REQUEST_ACTION = createAction(
//   SAVE_PATIENT_CONDITION_REQUEST
// );
// const SAVE_PATIENT_CONDITION_SUCCESS = `${
//   app.NS
// }save_patient_condition_success`;

// export const SAVE_PATIENT_CONDITION_SUCCESS_ACTION = createAction(
//   SAVE_PATIENT_CONDITION_SUCCESS,
//   patientCondition => ({
//     patientCondition
//   })
// );
// const SAVE_PATIENT_CONDITION_FAILURE = `${NS}save_user_failure`;
// export const SAVE_PATIENT_CONDITION_FAILURE_ACTION = createAction(
//   SAVE_PATIENT_CONDITION_FAILURE
// );

// export const savePatientConditionRequest = id => {
//   const action = SAVE_PATIENT_CONDITION_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const savePatientConditionSuccess = user => {
//   const action = SAVE_PATIENT_CONDITION_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const savePatientConditionFailure = error => {
//   const action = SAVE_PATIENT_CONDITION_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

/*********************************/
/* SAVE_CONDITION_REQUEST  */
/*********************************/
const SAVE_CONDITION_REQUEST = `${NS}save_condition_request`;
export const SAVE_CONDITION_REQUEST_ACTION = createAction(
  SAVE_CONDITION_REQUEST
);
const SAVE_CONDITION_SUCCESS = `${NS}save_condition_success`;

export const SAVE_CONDITION_SUCCESS_ACTION = createAction(
  SAVE_CONDITION_SUCCESS,
  condition => ({
    condition
  })
);
const SAVE_CONDITION_FAILURE = `${NS}save_condition_failure`;
export const SAVE_CONDITION_FAILURE_ACTION = createAction(
  SAVE_CONDITION_FAILURE
);

export const saveConditionRequest = id => {
  const action = SAVE_CONDITION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const saveConditionSuccess = user => {
  const action = SAVE_CONDITION_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const saveConditionFailure = error => {
  const action = SAVE_CONDITION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_CONDITION_REQUEST  */
/*********************************/
const DELETE_CONDITION_REQUEST = `${NS}delete_condition_request`;
export const DELETE_CONDITION_REQUEST_ACTION = createAction(
  DELETE_CONDITION_REQUEST
);
const DELETE_CONDITION_SUCCESS = `${NS}delete_condition_success`;

export const DELETE_CONDITION_SUCCESS_ACTION = createAction(
  DELETE_CONDITION_SUCCESS,
  condition => ({
    condition
  })
);
const DELETE_CONDITION_FAILURE = `${NS}delete_condition_failure`;
export const DELETE_CONDITION_FAILURE_ACTION = createAction(
  DELETE_CONDITION_FAILURE
);

export const deleteConditionRequest = id => {
  const action = DELETE_CONDITION_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteConditionSuccess = user => {
  const action = DELETE_CONDITION_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deleteConditionFailure = error => {
  const action = DELETE_CONDITION_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

// /*********************************/
// /* DELETE_PATIENT_CONDITION_REQUEST  */
// /*********************************/
// const DELETE_PATIENT_CONDITION_REQUEST = `${
//   app.NS
// }delete_patientCondition_request`;
// export const DELETE_PATIENT_CONDITION_REQUEST_ACTION = createAction(
//   DELETE_PATIENT_CONDITION_REQUEST
// );
// const DELETE_PATIENT_CONDITION_SUCCESS = `${
//   app.NS
// }delete_patientCondition_success`;

// export const DELETE_PATIENT_CONDITION_SUCCESS_ACTION = createAction(
//   DELETE_PATIENT_CONDITION_SUCCESS,
//   patientCondition => ({
//     patientCondition
//   })
// );
// const DELETE_PATIENT_CONDITION_FAILURE = `${
//   app.NS
// }delete_patientCondition_failure`;
// export const DELETE_PATIENT_CONDITION_FAILURE_ACTION = createAction(
//   DELETE_PATIENT_CONDITION_FAILURE
// );

// export const deletePatientConditionRequest = id => {
//   const action = DELETE_PATIENT_CONDITION_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const deletePatientConditionSuccess = user => {
//   const action = DELETE_PATIENT_CONDITION_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const deletePatientConditionFailure = error => {
//   const action = DELETE_PATIENT_CONDITION_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };
// /*********************************/
// /* DELETE_PATIENT_PROGRAM_ITEM_REQUEST  */
// /*********************************/
// const DELETE_PATIENT_PROGRAM_ITEM_REQUEST = `${NS}delete_patientProgramItem_request`;
// export const DELETE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION = createAction(
//   DELETE_PATIENT_PROGRAM_ITEM_REQUEST
// );
// const DELETE_PATIENT_PROGRAM_ITEM_SUCCESS = `${NS}delete_patientProgramItem_success`;

// export const DELETE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
//   DELETE_PATIENT_PROGRAM_ITEM_SUCCESS,
//   patientProgramItem => ({
//     patientProgramItem
//   })
// );
// const DELETE_PATIENT_PROGRAM_ITEM_FAILURE = `${NS}delete_patientProgramItem_failure`;
// export const DELETE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION = createAction(
//   DELETE_PATIENT_PROGRAM_ITEM_FAILURE
// );

// export const deletePatientProgramItemRequest = id => {
//   const action = DELETE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const deletePatientProgramItemSuccess = user => {
//   const action = DELETE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const deletePatientProgramItemFailure = error => {
//   const action = DELETE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /* DELETE_PATIENT_PROGRAM_REQUEST  */
// /*********************************/
// const DELETE_PATIENT_PROGRAM_REQUEST = `${NS}delete_patientProgram_request`;
// export const DELETE_PATIENT_PROGRAM_REQUEST_ACTION = createAction(
//   DELETE_PATIENT_PROGRAM_REQUEST
// );
// const DELETE_PATIENT_PROGRAM_SUCCESS = `${NS}delete_patientProgram_success`;

// export const DELETE_PATIENT_PROGRAM_SUCCESS_ACTION = createAction(
//   DELETE_PATIENT_PROGRAM_SUCCESS,
//   patientProgram => ({
//     patientProgram
//   })
// );
// const DELETE_PATIENT_PROGRAM_FAILURE = `${NS}delete_patientProgram_failure`;
// export const DELETE_PATIENT_PROGRAM_FAILURE_ACTION = createAction(
//   DELETE_PATIENT_PROGRAM_FAILURE
// );

// export const deletePatientProgramRequest = id => {
//   const action = DELETE_PATIENT_PROGRAM_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const deletePatientProgramSuccess = user => {
//   const action = DELETE_PATIENT_PROGRAM_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const deletePatientProgramFailure = error => {
//   const action = DELETE_PATIENT_PROGRAM_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };
// /*********************************/
// /* SAVE_PATIENT_PROGRAM_REQUEST  */
// /*********************************/
// const SAVE_PATIENT_PROGRAM_REQUEST = `${NS}save_patient_program_request`;
// export const SAVE_PATIENT_PROGRAM_REQUEST_ACTION = createAction(
//   SAVE_PATIENT_PROGRAM_REQUEST
// );
// const SAVE_PATIENT_PROGRAM_SUCCESS = `${NS}save_patient_program_success`;

// export const SAVE_PATIENT_PROGRAM_SUCCESS_ACTION = createAction(
//   SAVE_PATIENT_PROGRAM_SUCCESS,
//   patientProgram => ({
//     patientProgram
//   })
// );
// const SAVE_PATIENT_PROGRAM_FAILURE = `${NS}save_user_failure`;
// export const SAVE_PATIENT_PROGRAM_FAILURE_ACTION = createAction(
//   SAVE_PATIENT_PROGRAM_FAILURE
// );

// export const savePatientProgramRequest = id => {
//   const action = SAVE_PATIENT_PROGRAM_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const savePatientProgramSuccess = user => {
//   const action = SAVE_PATIENT_PROGRAM_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const savePatientProgramFailure = error => {
//   const action = SAVE_PATIENT_PROGRAM_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /**************************************/
// /* SAVE_PATIENT_PROGRAM_ITEM_REQUEST  */
// /**************************************/
// const SAVE_PATIENT_PROGRAM_ITEM_REQUEST = `${
//   app.NS
// }save_patientProgram_item_request`;
// export const SAVE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION = createAction(
//   SAVE_PATIENT_PROGRAM_ITEM_REQUEST
// );
// const SAVE_PATIENT_PROGRAM_ITEM_SUCCESS = `${
//   app.NS
// }save_patientProgram_item_success`;

// export const SAVE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
//   SAVE_PATIENT_PROGRAM_ITEM_SUCCESS,
//   patientProgramItem => ({
//     patientProgramItem
//   })
// );
// const SAVE_PATIENT_PROGRAM_ITEM_FAILURE = `${
//   app.NS
// }save_patientProgram_item_failure`;
// export const SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION = createAction(
//   SAVE_PATIENT_PROGRAM_ITEM_FAILURE
// );

// export const savePatientProgramItemRequest = id => {
//   const action = SAVE_PATIENT_PROGRAM_ITEM_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const savePatientProgramItemSuccess = patientProgramItem => {
//   const action = SAVE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION(patientProgramItem);
//   action[pendingTask] = end;
//   return action;
// };
// export const savePatientProgramItemFailure = error => {
//   const action = SAVE_PATIENT_PROGRAM_ITEM_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /* INSERT_PATIENT_PROGRAM_ITEM_REQUEST  */
// /*********************************/
// const INSERT_PATIENT_PROGRAM_ITEM_REQUEST = `${NS}insert_patientProgram_item_request`;
// export const INSERT_PATIENT_PROGRAM_ITEM_REQUEST_ACTION = createAction(
//   INSERT_PATIENT_PROGRAM_ITEM_REQUEST
// );
// const INSERT_PATIENT_PROGRAM_ITEM_SUCCESS = `${NS}insert_patientProgram_item_success`;

// export const INSERT_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
//   INSERT_PATIENT_PROGRAM_ITEM_SUCCESS,
//   patientProgramItem => ({
//     patientProgramItem
//   })
// );
// const INSERT_PATIENT_PROGRAM_ITEM_FAILURE = `${NS}insert_patientProgram_item_failure`;
// export const INSERT_PATIENT_PROGRAM_ITEM_FAILURE_ACTION = createAction(
//   INSERT_PATIENT_PROGRAM_ITEM_FAILURE
// );

// export const insertPatientProgramItemRequest = id => {
//   const action = INSERT_PATIENT_PROGRAM_ITEM_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const insertPatientProgramItemSuccess = user => {
//   const action = INSERT_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION(user);
//   action[pendingTask] = end;
//   return action;
// };
// export const insertPatientProgramItemFailure = error => {
//   const action = INSERT_PATIENT_PROGRAM_ITEM_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

// /*********************************/
// /*     LOAD_PATIENT_PROGRAM_REQUEST      */
// /*********************************/
// const LOAD_PATIENT_PROGRAM_REQUEST = `${NS}load_patient_program_request`;
// export const LOAD_PATIENT_PROGRAM_REQUEST_ACTION = createAction(
//   LOAD_PATIENT_PROGRAM_REQUEST
// );
// const LOAD_PATIENT_PROGRAM_SUCCESS = `${NS}load_patient_program_success`;
// export const LOAD_PATIENT_PROGRAM_SUCCESS_ACTION = createAction(
//   LOAD_PATIENT_PROGRAM_SUCCESS,
//   patientProgram => ({
//     patientProgram
//   })
// );
// const LOAD_PATIENT_PROGRAM_FAILURE = `${NS}load_patient_program_failure`;
// export const LOAD_PATIENT_PROGRAM_FAILURE_ACTION = createAction(
//   LOAD_PATIENT_PROGRAM_FAILURE
// );

// export const loadPatientProgramRequest = id => {
//   const action = LOAD_PATIENT_PROGRAM_REQUEST_ACTION(id);
//   action[pendingTask] = begin;
//   return action;
// };
// export const loadPatientProgramSuccess = patientProgram => {
//   const action = LOAD_PATIENT_PROGRAM_SUCCESS_ACTION(patientProgram);
//   action[pendingTask] = end;
//   return action;
// };
// export const loadPatientProgramFailure = error => {
//   const action = LOAD_PATIENT_PROGRAM_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

/*********************************/
/*     LOAD_PROGRAMS_REQUEST     */
/*********************************/

const LOAD_PROGRAMS_REQUEST = `${NS}load_programs_request`;
export const LOAD_PROGRAMS_REQUEST_ACTION = createAction(LOAD_PROGRAMS_REQUEST);
const LOAD_PROGRAMS_SUCCESS = `${NS}load_programs_success`;
export const LOAD_PROGRAMS_SUCCESS_ACTION = createAction(
  LOAD_PROGRAMS_SUCCESS,
  programs => ({
    programs
  })
);
const LOAD_PROGRAMS_FAILURE = `${NS}load_programs_failure`;
export const LOAD_PROGRAMS_FAILURE_ACTION = createAction(LOAD_PROGRAMS_FAILURE);

export const loadProgramsRequest = searchTerm => {
  const action = LOAD_PROGRAMS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadProgramsSuccess = programs => {
  const action = LOAD_PROGRAMS_SUCCESS_ACTION(programs);
  action[pendingTask] = end;
  return action;
};
export const loadProgramsFailure = error => {
  const action = LOAD_PROGRAMS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*     LOAD_PROGRAM_REQUEST      */
/*********************************/
const LOAD_PROGRAM_REQUEST = `${NS}load_program_request`;
export const LOAD_PROGRAM_REQUEST_ACTION = createAction(LOAD_PROGRAM_REQUEST);
const LOAD_PROGRAM_SUCCESS = `${NS}load_program_success`;
export const LOAD_PROGRAM_SUCCESS_ACTION = createAction(
  LOAD_PROGRAM_SUCCESS,
  program => ({
    program
  })
);
const LOAD_PROGRAM_FAILURE = `${NS}load_program_failure`;
export const LOAD_PROGRAM_FAILURE_ACTION = createAction(LOAD_PROGRAM_FAILURE);

export const loadProgramRequest = id => {
  const action = LOAD_PROGRAM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadProgramSuccess = program => {
  const action = LOAD_PROGRAM_SUCCESS_ACTION(program);
  action[pendingTask] = end;
  return action;
};
export const loadProgramFailure = error => {
  const action = LOAD_PROGRAM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SAVE_PROGRAM_REQUEST  */
/*********************************/
const SAVE_PROGRAM_REQUEST = `${NS}save_program_request`;
export const SAVE_PROGRAM_REQUEST_ACTION = createAction(SAVE_PROGRAM_REQUEST);
const SAVE_PROGRAM_SUCCESS = `${NS}save_program_success`;

export const SAVE_PROGRAM_SUCCESS_ACTION = createAction(
  SAVE_PROGRAM_SUCCESS,
  program => ({
    program
  })
);
const SAVE_PROGRAM_FAILURE = `${NS}save_program_failure`;
export const SAVE_PROGRAM_FAILURE_ACTION = createAction(SAVE_PROGRAM_FAILURE);

export const saveProgramRequest = id => {
  const action = SAVE_PROGRAM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const saveProgramSuccess = user => {
  const action = SAVE_PROGRAM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const saveProgramFailure = error => {
  const action = SAVE_PROGRAM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SAVE_PROGRAM_ITEM_REQUEST  */
/*********************************/
const SAVE_PROGRAM_ITEM_REQUEST = `${NS}save_program_item_request`;
export const SAVE_PROGRAM_ITEM_REQUEST_ACTION = createAction(
  SAVE_PROGRAM_ITEM_REQUEST
);
const SAVE_PROGRAM_ITEM_SUCCESS = `${NS}save_program_item_success`;

export const SAVE_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
  SAVE_PROGRAM_ITEM_SUCCESS,
  programItem => ({
    programItem
  })
);
const SAVE_PROGRAM_ITEM_FAILURE = `${NS}save_program_item_failure`;
export const SAVE_PROGRAM_ITEM_FAILURE_ACTION = createAction(
  SAVE_PROGRAM_ITEM_FAILURE
);

export const saveProgramItemRequest = id => {
  const action = SAVE_PROGRAM_ITEM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const saveProgramItemSuccess = user => {
  const action = SAVE_PROGRAM_ITEM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const saveProgramItemFailure = error => {
  const action = SAVE_PROGRAM_ITEM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* INSERT_PROGRAM_ITEM_REQUEST  */
/*********************************/
const INSERT_PROGRAM_ITEM_REQUEST = `${NS}insert_program_item_request`;
export const INSERT_PROGRAM_ITEM_REQUEST_ACTION = createAction(
  INSERT_PROGRAM_ITEM_REQUEST
);
const INSERT_PROGRAM_ITEM_SUCCESS = `${NS}insert_program_item_success`;

export const INSERT_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
  INSERT_PROGRAM_ITEM_SUCCESS,
  programItem => ({
    programItem
  })
);
const INSERT_PROGRAM_ITEM_FAILURE = `${NS}insert_program_item_failure`;
export const INSERT_PROGRAM_ITEM_FAILURE_ACTION = createAction(
  INSERT_PROGRAM_ITEM_FAILURE
);

export const insertProgramItemRequest = id => {
  const action = INSERT_PROGRAM_ITEM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const insertProgramItemSuccess = user => {
  const action = INSERT_PROGRAM_ITEM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const insertProgramItemFailure = error => {
  const action = INSERT_PROGRAM_ITEM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DUPLICATE_PROGRAM_REQUEST  */
/*********************************/
const DUPLICATE_PROGRAM_REQUEST = `${NS}duplicate_program_request`;
export const DUPLICATE_PROGRAM_REQUEST_ACTION = createAction(
  DUPLICATE_PROGRAM_REQUEST
);
const DUPLICATE_PROGRAM_SUCCESS = `${NS}duplicate_program_success`;

export const DUPLICATE_PROGRAM_SUCCESS_ACTION = createAction(
  DUPLICATE_PROGRAM_SUCCESS,
  program => ({
    program
  })
);
const DUPLICATE_PROGRAM_FAILURE = `${NS}duplicate_program_failure`;
export const DUPLICATE_PROGRAM_FAILURE_ACTION = createAction(
  DUPLICATE_PROGRAM_FAILURE
);

export const duplicateProgramRequest = id => {
  const action = DUPLICATE_PROGRAM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const duplicateProgramSuccess = user => {
  const action = DUPLICATE_PROGRAM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const duplicateProgramFailure = error => {
  const action = DUPLICATE_PROGRAM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_PROGRAM_ITEM_REQUEST  */
/*********************************/
const DELETE_PROGRAM_ITEM_REQUEST = `${NS}delete_program_item_request`;
export const DELETE_PROGRAM_ITEM_REQUEST_ACTION = createAction(
  DELETE_PROGRAM_ITEM_REQUEST
);
const DELETE_PROGRAM_ITEM_SUCCESS = `${NS}delete_program_item_success`;

export const DELETE_PROGRAM_ITEM_SUCCESS_ACTION = createAction(
  DELETE_PROGRAM_ITEM_SUCCESS,
  programItem => ({
    programItem
  })
);
const DELETE_PROGRAM_ITEM_FAILURE = `${NS}delete_program_item_failure`;
export const DELETE_PROGRAM_ITEM_FAILURE_ACTION = createAction(
  DELETE_PROGRAM_ITEM_FAILURE
);

export const deleteProgramItemRequest = id => {
  const action = DELETE_PROGRAM_ITEM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteProgramItemSuccess = user => {
  const action = DELETE_PROGRAM_ITEM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deleteProgramItemFailure = error => {
  const action = DELETE_PROGRAM_ITEM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_PROGRAM_REQUEST  */
/*********************************/
const DELETE_PROGRAM_REQUEST = `${NS}delete_program_request`;
export const DELETE_PROGRAM_REQUEST_ACTION = createAction(
  DELETE_PROGRAM_REQUEST
);
const DELETE_PROGRAM_SUCCESS = `${NS}delete_program_success`;

export const DELETE_PROGRAM_SUCCESS_ACTION = createAction(
  DELETE_PROGRAM_SUCCESS,
  program => ({
    program
  })
);
const DELETE_PROGRAM_FAILURE = `${NS}delete_program_failure`;
export const DELETE_PROGRAM_FAILURE_ACTION = createAction(
  DELETE_PROGRAM_FAILURE
);

export const deleteProgramRequest = id => {
  const action = DELETE_PROGRAM_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteProgramSuccess = user => {
  const action = DELETE_PROGRAM_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deleteProgramFailure = error => {
  const action = DELETE_PROGRAM_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*      LOAD_TASKS_REQUEST       */
/*********************************/
const LOAD_TASKS_REQUEST = `${NS}load_tasks_request`;
export const LOAD_TASKS_REQUEST_ACTION = createAction(LOAD_TASKS_REQUEST);
const LOAD_TASKS_SUCCESS = `${NS}load_tasks_success`;
export const LOAD_TASKS_SUCCESS_ACTION = createAction(
  LOAD_TASKS_SUCCESS,
  tasks => ({
    tasks
  })
);
const LOAD_TASKS_FAILURE = `${NS}load_tasks_failure`;
export const LOAD_TASKS_FAILURE_ACTION = createAction(LOAD_TASKS_FAILURE);

export const loadTasksRequest = searchTerm => {
  const action = LOAD_TASKS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadTasksSuccess = tasks => {
  const action = LOAD_TASKS_SUCCESS_ACTION(tasks);
  action[pendingTask] = end;
  return action;
};
export const loadTasksFailure = error => {
  const action = LOAD_TASKS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* SAVE_TASK_REQUEST  */
/*********************************/
const SAVE_TASK_REQUEST = `${NS}save_task_request`;
export const SAVE_TASK_REQUEST_ACTION = createAction(SAVE_TASK_REQUEST);
const SAVE_TASK_SUCCESS = `${NS}save_task_success`;

export const SAVE_TASK_SUCCESS_ACTION = createAction(
  SAVE_TASK_SUCCESS,
  task => ({
    task
  })
);
const SAVE_TASK_FAILURE = `${NS}save_task_failure`;
export const SAVE_TASK_FAILURE_ACTION = createAction(SAVE_TASK_FAILURE);

export const saveTaskRequest = id => {
  const action = SAVE_TASK_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const saveTaskSuccess = user => {
  const action = SAVE_TASK_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const saveTaskFailure = error => {
  const action = SAVE_TASK_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/* DELETE_TASK_REQUEST  */
/*********************************/
const DELETE_TASK_REQUEST = `${NS}delete_task_request`;
export const DELETE_TASK_REQUEST_ACTION = createAction(DELETE_TASK_REQUEST);
const DELETE_TASK_SUCCESS = `${NS}delete_task_success`;

export const DELETE_TASK_SUCCESS_ACTION = createAction(
  DELETE_TASK_SUCCESS,
  task => ({
    task
  })
);
const DELETE_TASK_FAILURE = `${NS}delete_task_failure`;
export const DELETE_TASK_FAILURE_ACTION = createAction(DELETE_TASK_FAILURE);

export const deleteTaskRequest = id => {
  const action = DELETE_TASK_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const deleteTaskSuccess = user => {
  const action = DELETE_TASK_SUCCESS_ACTION(user);
  action[pendingTask] = end;
  return action;
};
export const deleteTaskFailure = error => {
  const action = DELETE_TASK_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*   LOAD_CONDITIONS_REQUEST     */
/*********************************/
const LOAD_CONDITIONS_REQUEST = `${NS}load_conditions_request`;
export const LOAD_CONDITIONS_REQUEST_ACTION = createAction(
  LOAD_CONDITIONS_REQUEST
);
const LOAD_CONDITIONS_SUCCESS = `${NS}load_conditions_success`;
export const LOAD_CONDITIONS_SUCCESS_ACTION = createAction(
  LOAD_CONDITIONS_SUCCESS,
  conditions => ({
    conditions
  })
);
const LOAD_CONDITIONS_FAILURE = `${NS}load_conditions_failure`;
export const LOAD_CONDITIONS_FAILURE_ACTION = createAction(
  LOAD_CONDITIONS_FAILURE
);

export const loadConditionsRequest = searchTerm => {
  const action = LOAD_CONDITIONS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadConditionsSuccess = conditions => {
  const action = LOAD_CONDITIONS_SUCCESS_ACTION(conditions);
  action[pendingTask] = end;
  return action;
};
export const loadConditionsFailure = error => {
  const action = LOAD_CONDITIONS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

// /*********************************/
// /*     LINK_PROGRAM_REQUEST      */
// /*********************************/
// const LINK_PROGRAM_REQUEST = `${NS}link_program_request`;
// export const LINK_PROGRAM_REQUEST_ACTION = createAction(LINK_PROGRAM_REQUEST);
// const LINK_PROGRAM_SUCCESS = `${NS}link_program_success`;
// export const LINK_PROGRAM_SUCCESS_ACTION = createAction(
//   LINK_PROGRAM_SUCCESS,
//   programs => ({
//     programs
//   })
// );
// const LINK_PROGRAMS_FAILURE = `${NS}load_conditions_failure`;
// export const LINK_PROGRAMS_FAILURE_ACTION = createAction(LINK_PROGRAMS_FAILURE);

// export const linkProgramRequest = program => {
//   const action = LINK_PROGRAM_REQUEST_ACTION(program);
//   action[pendingTask] = begin;
//   return action;
// };
// export const linkProgramSuccess = programs => {
//   const action = LINK_PROGRAM_SUCCESS_ACTION(programs);
//   action[pendingTask] = end;
//   return action;
// };
// export const linkProgramFailure = error => {
//   const action = LINK_PROGRAMS_FAILURE_ACTION(error);
//   action[pendingTask] = end;
//   return action;
// };

/*********************************/
/*   LOAD_ATTACHMENTS_REQUEST     */
/*********************************/
const LOAD_ATTACHMENTS_REQUEST = `${NS}load_attachments_request`;
export const LOAD_ATTACHMENTS_REQUEST_ACTION = createAction(
  LOAD_ATTACHMENTS_REQUEST
);
const LOAD_ATTACHMENTS_SUCCESS = `${NS}load_attachments_success`;
export const LOAD_ATTACHMENTS_SUCCESS_ACTION = createAction(
  LOAD_ATTACHMENTS_SUCCESS,
  attachments => ({
    attachments
  })
);
const LOAD_ATTACHMENTS_FAILURE = `${NS}load_attachments_failure`;
export const LOAD_ATTACHMENTS_FAILURE_ACTION = createAction(
  LOAD_ATTACHMENTS_FAILURE
);

export const loadAttachmentsRequest = searchTerm => {
  const action = LOAD_ATTACHMENTS_REQUEST_ACTION(searchTerm);
  action[pendingTask] = begin;
  return action;
};
export const loadAttachmentsSuccess = attachments => {
  const action = LOAD_ATTACHMENTS_SUCCESS_ACTION(attachments);
  action[pendingTask] = end;
  return action;
};
export const loadAttachmentsFailure = error => {
  const action = LOAD_ATTACHMENTS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*   UPLOAD_ATTACHMENTS_REQUEST     */
/*********************************/
const UPLOAD_ATTACHMENTS_REQUEST = `${NS}upload_attachments_request`;
export const UPLOAD_ATTACHMENTS_REQUEST_ACTION = createAction(
  UPLOAD_ATTACHMENTS_REQUEST
);
const UPLOAD_ATTACHMENTS_SUCCESS = `${NS}upload_attachments_success`;
export const UPLOAD_ATTACHMENTS_SUCCESS_ACTION = createAction(
  UPLOAD_ATTACHMENTS_SUCCESS,
  attachments => ({
    attachments
  })
);
const UPLOAD_ATTACHMENTS_FAILURE = `${NS}upload_attachments_failure`;
export const UPLOAD_ATTACHMENTS_FAILURE_ACTION = createAction(
  UPLOAD_ATTACHMENTS_FAILURE
);

export const uploadAttachmentsRequest = files => {
  const action = UPLOAD_ATTACHMENTS_REQUEST_ACTION(files);
  action[pendingTask] = begin;
  return action;
};
export const uploadAttachmentsSuccess = attachments => {
  const action = UPLOAD_ATTACHMENTS_SUCCESS_ACTION(attachments);
  action[pendingTask] = end;
  return action;
};
export const uploadAttachmentsFailure = error => {
  const action = UPLOAD_ATTACHMENTS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*   ATTACH_ATTACHMENTS_REQUEST     */
/*********************************/
const ATTACH_ATTACHMENTS_REQUEST = `${NS}attach_attachments_request`;
export const ATTACH_ATTACHMENTS_REQUEST_ACTION = createAction(
  ATTACH_ATTACHMENTS_REQUEST
);
const ATTACH_ATTACHMENTS_SUCCESS = `${NS}attach_attachments_success`;
export const ATTACH_ATTACHMENTS_SUCCESS_ACTION = createAction(
  ATTACH_ATTACHMENTS_SUCCESS,
  attachments => ({
    attachments
  })
);
const ATTACH_ATTACHMENTS_FAILURE = `${NS}attach_attachments_failure`;
export const ATTACH_ATTACHMENTS_FAILURE_ACTION = createAction(
  ATTACH_ATTACHMENTS_FAILURE
);

export const attachAttachmentsRequest = files => {
  const action = ATTACH_ATTACHMENTS_REQUEST_ACTION(files);
  action[pendingTask] = begin;
  return action;
};
export const attachAttachmentsSuccess = attachments => {
  const action = ATTACH_ATTACHMENTS_SUCCESS_ACTION(attachments);
  action[pendingTask] = end;
  return action;
};
export const attachAttachmentsFailure = error => {
  const action = ATTACH_ATTACHMENTS_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*   LOAD_HISTORY_REQUEST     */
/*********************************/
const LOAD_HISTORY_REQUEST = `${NS}load_history_request`;
export const LOAD_HISTORY_REQUEST_ACTION = createAction(LOAD_HISTORY_REQUEST);
const LOAD_HISTORY_SUCCESS = `${NS}load_history_success`;
export const LOAD_HISTORY_SUCCESS_ACTION = createAction(
  LOAD_HISTORY_SUCCESS,
  data => ({
    data
  })
);
const LOAD_HISTORY_FAILURE = `${NS}load_history_failure`;
export const LOAD_HISTORY_FAILURE_ACTION = createAction(LOAD_HISTORY_FAILURE);

export const loadHistoryRequest = data => {
  const action = LOAD_HISTORY_REQUEST_ACTION(data);
  action[pendingTask] = begin;
  return action;
};
export const loadHistorySuccess = history => {
  const action = LOAD_HISTORY_SUCCESS_ACTION(history);
  action[pendingTask] = end;
  return action;
};
export const loadHistoryFailure = error => {
  const action = LOAD_HISTORY_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*   LOAD_ACTIVITY_REQUEST     */
/*********************************/
const LOAD_ACTIVITY_REQUEST = `${NS}load_activity_request`;
export const LOAD_ACTIVITY_REQUEST_ACTION = createAction(LOAD_ACTIVITY_REQUEST);
const LOAD_ACTIVITY_SUCCESS = `${NS}load_activity_success`;
export const LOAD_ACTIVITY_SUCCESS_ACTION = createAction(
  LOAD_ACTIVITY_SUCCESS,
  patientProgramActivities => ({
    patientProgramActivities
  })
);
const LOAD_ACTIVITY_FAILURE = `${NS}load_activity_failure`;
export const LOAD_ACTIVITY_FAILURE_ACTION = createAction(LOAD_ACTIVITY_FAILURE);

export const loadActivityRequest = id => {
  const action = LOAD_ACTIVITY_REQUEST_ACTION(id);
  action[pendingTask] = begin;
  return action;
};
export const loadActivitySuccess = patientProgramActivities => {
  const action = LOAD_ACTIVITY_SUCCESS_ACTION(patientProgramActivities);
  action[pendingTask] = end;
  return action;
};
export const loadActivityFailure = error => {
  const action = LOAD_ACTIVITY_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*   USER_LOOKUP_REQUEST     */
/*********************************/
const USER_LOOKUP_REQUEST = `${NS}user_lookup_request`;
export const USER_LOOKUP_REQUEST_ACTION = createAction(USER_LOOKUP_REQUEST);
const USER_LOOKUP_SUCCESS = `${NS}user_lookup_success`;
export const USER_LOOKUP_SUCCESS_ACTION = createAction(
  USER_LOOKUP_SUCCESS,
  users => ({
    users
  })
);
const USER_LOOKUP_FAILURE = `${NS}user_lookup_failure`;
export const USER_LOOKUP_FAILURE_ACTION = createAction(USER_LOOKUP_FAILURE);

export const userLookupRequest = email => {
  const action = USER_LOOKUP_REQUEST_ACTION(email);
  action[pendingTask] = begin;
  return action;
};
export const userLookupSuccess = users => {
  const action = USER_LOOKUP_SUCCESS_ACTION(users);
  action[pendingTask] = end;
  return action;
};
export const userLookupFailure = error => {
  const action = USER_LOOKUP_FAILURE_ACTION(error);
  action[pendingTask] = end;
  return action;
};

/*********************************/
/*       INITIALISE STATE        */
/*********************************/
const initialState = {
  loadingPatients: false,
  loadingPatient: false,
  loadingPrograms: false,
  loadingTasks: false,
  loadingConditions: false
};
export default createReducer(
  {
    [LOAD_DASHBOARD_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingDashboard: true });
    },
    [LOAD_DASHBOARD_SUCCESS_ACTION]: (state, { dashboard }) => {
      let newState = Object.assign({}, state);
      newState.dashboard = {};
      return merge(
        {},
        newState,
        merge(
          {},
          { dashboard: { ...dashboard.dashboardUsers } },
          { loadingDashboard: false }
        )
      );
    },
    [LOAD_DASHBOARD_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingDashboard: false });
    },

    [USER_LOOKUP_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingUserLookup: true });
    },
    [USER_LOOKUP_SUCCESS_ACTION]: (state, { users }) => {
      let newState = Object.assign({}, state);
      newState.userLookup = {};
      return merge(
        {},
        newState,
        merge({}, { userLookup: { ...users } }, { loadingUserLookup: false })
      );
    },
    [USER_LOOKUP_FAILURE]: state => {
      return merge({}, state, { loadingUserLookup: false });
    },

    [LOAD_ACCOUNTS_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingAccounts: true });
    },
    [LOAD_ACCOUNTS_SUCCESS_ACTION]: (state, { accounts }) => {
      let newState = Object.assign({}, state);
      newState.accounts = {};

      return merge(
        {},
        newState,
        merge({}, accounts, { loadingAccounts: false })
      );
    },
    [LOAD_ACCOUNTS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingAccounts: false });
    },

    [LOAD_ACTIVITY_REQUEST_ACTION]: state => {
      let newState = Object.assign({}, state);
      newState.patientProgramActivities = {};

      return merge({}, newState, { loadingActivity: false });
    },
    [LOAD_ACTIVITY_SUCCESS_ACTION]: (state, { patientProgramActivities }) => {
      let newState = Object.assign({}, state);
      newState.patientProgramActivities = {};

      return merge(
        {},
        newState,
        merge({}, patientProgramActivities, { loadingActivity: false })
      );
    },
    [LOAD_ACCOUNTS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingActivity: false });
    },

    [LOAD_ACCOUNT_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingAccount: true });
    },
    [LOAD_ACCOUNT_SUCCESS_ACTION]: (state, { account }) => {
      return merge({}, state, merge({}, account, { loadingAccount: false }));
    },
    [LOAD_ACCOUNT_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingAccount: false });
    },

    [LOAD_ACTIVE_ACCOUNT_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingAccount: true });
    },
    [LOAD_ACTIVE_ACCOUNT_SUCCESS_ACTION]: (state, { account }) => {
      return merge({}, state, merge({}, account, { loadingAccount: false }));
    },
    [LOAD_ACTIVE_ACCOUNT_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingAccount: false });
    },

    [SAVE_ACCOUNT_SUCCESS_ACTION]: (state, { account }) => {
      return merge({}, state, merge({}, account, { loadingAccounts: false }));
    },

    /* USER */
    [LOAD_USERS_REQUEST_ACTION]: state => {
      let newState = Object.assign({}, state);
      newState.users = {};
      return merge({}, newState, { loadingUsers: true });
    },
    [LOAD_USERS_SUCCESS_ACTION]: (state, { users }) => {
      let newState = Object.assign({}, state);
      newState.users = {};

      return merge({}, newState, merge({}, users, { loadingUsers: false }));
    },
    [LOAD_USERS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingUsers: false });
    },

    [LOAD_CLINICIANS_SUCCESS_ACTION]: (state, { clinicians }) => {
      let newState = Object.assign({}, state);
      newState.clinicians = {};

      return merge(
        {},
        newState,
        merge({}, clinicians, { loadingClinicians: false })
      );
    },
    [LOAD_USER_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingUser: true });
    },
    [LOAD_USER_SUCCESS_ACTION]: (state, { user }) => {
      return merge({}, state, merge({}, user, { loadingUser: false }));
    },
    [LOAD_USER_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingUser: false });
    },

    [SAVE_USER_SUCCESS_ACTION]: (state, { user }) => {
      return merge({}, state, merge({}, user, { loadingUsers: false }));
    },

    /* LOCATION */
    [LOAD_LOCATIONS_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingLocations: true });
    },
    [LOAD_LOCATIONS_SUCCESS_ACTION]: (state, { locations }) => {
      let newState = Object.assign({}, state);
      newState.locations = {};

      return merge(
        {},
        newState,
        merge({}, locations, { loadingLocations: false })
      );
    },
    [LOAD_LOCATIONS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingLocations: false });
    },

    [LOAD_LOCATION_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingLocation: true });
    },
    [LOAD_LOCATION_SUCCESS_ACTION]: (state, { location }) => {
      return merge({}, state, merge({}, location, { loadingLocation: false }));
    },
    [LOAD_LOCATION_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingLocation: false });
    },

    [SAVE_LOCATION_SUCCESS_ACTION]: (state, { location }) => {
      return merge({}, state, merge({}, location, { loadingLocations: false }));
    },

    [DELETE_LOCATION_SUCCESS_ACTION]: (state, { location }) => {
      let newState = Object.assign({}, state);
      delete newState.locations[location.id];
      return newState;
    },

    /* PATIENTS */
    [LOAD_PATIENTS_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingPatients: true });
    },
    [LOAD_PATIENTS_SUCCESS_ACTION]: (state, { searchTerm, patients }) => {
      /* Clear out the patients for the search... */
      let newState = Object.assign({}, state);
      newState.patients = {};

      return merge(
        {},
        newState,
        merge({}, patients, { loadingPatients: false })
      );
    },

    [SAVE_PATIENT_SUCCESS_ACTION]: (state, { patients }) => {
      return merge({}, state, merge({}, patients, { loadingPatients: false }));
    },
    [SAVE_PATIENT_CONDITION_SUCCESS_ACTION]: (state, { patientCondition }) => {
      return merge(
        {},
        state,
        merge({}, patientCondition, { loadingPatients: false })
      );
    },

    // [SAVE_PATIENT_PROGRAM_SUCCESS_ACTION]: (state, { patientProgram }) => {
    //   return merge(
    //     {},
    //     state,
    //     merge({}, patientProgram, { loadingPatients: false })
    //   );
    // },
    // [LINK_PROGRAM_SUCCESS_ACTION]: (state, { programs }) => {
    //   return merge({}, state, merge({}, programs, { loadingPatients: false }));
    // },

    [LOAD_PATIENTS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingPatients: false });
    },
    [LOAD_PATIENT_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingPatient: true });
    },
    [LOAD_PATIENT_SUCCESS_ACTION]: (state, { patient }) => {
      return merge({}, state, merge({}, patient, { loadingPatient: false }));
    },

    [DELETE_PATIENT_SUCCESS_ACTION]: (state, { patient }) => {
      let newState = Object.assign({}, state);
      delete newState.patients[patient.id];
      return newState;
    },
    // [DELETE_SUPPORT_USER_SUCCESS_ACTION]: (state, { supportUser }) => {
    //   return merge(
    //     {},
    //     state,
    //     merge({}, supportUser, { loadingPatient: false })
    //   );
    // },

    [LOAD_USERS_SUCCESS_ACTION]: (state, { users }) => {
      return merge({}, state, merge({}, users, { loadingUsers: false }));
    },
    [LOAD_PATIENT_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingPatient: false });
    },

    [LOAD_PROGRAMS_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingPrograms: true });
    },
    [LOAD_PROGRAMS_SUCCESS_ACTION]: (state, { programs }) => {
      let newState = Object.assign({}, state);
      newState.programs = {};

      return merge(
        {},
        newState,
        merge({}, programs, { loadingPrograms: false })
      );
    },
    [LOAD_PROGRAMS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingPrograms: false });
    },

    [LOAD_PROGRAM_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingProgram: true });
    },
    [LOAD_PROGRAM_SUCCESS_ACTION]: (state, { program }) => {
      return merge({}, state, merge({}, program, { loadingProgram: false }));
    },
    [LOAD_PROGRAM_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingProgram: false });
    },
    [DUPLICATE_PROGRAM_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingProgram: true });
    },
    [DUPLICATE_PROGRAM_SUCCESS_ACTION]: (state, { program }) => {
      return merge({}, state, merge({}, program, { loadingProgram: false }));
    },
    [DUPLICATE_PROGRAM_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingProgram: false });
    },

    [SAVE_PROGRAM_SUCCESS_ACTION]: (state, { program }) => {
      return merge({}, state, merge({}, program, { loadingPrograms: false }));
    },
    [SAVE_PROGRAM_ITEM_SUCCESS_ACTION]: (state, { programItem }) => {
      return merge(
        {},
        state,
        merge({}, programItem, { loadingPrograms: false })
      );
    },
    [INSERT_PROGRAM_ITEM_SUCCESS_ACTION]: (state, { programItem }) => {
      return merge(
        {},
        state,
        merge({}, programItem, { loadingPrograms: false })
      );
    },
    [DELETE_PROGRAM_SUCCESS_ACTION]: (state, { program }) => {
      /* Clear out the patients for the search... */
      let newState = Object.assign({}, state);
      delete newState.programs[program.id];
      return newState;
    },
    // [DELETE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION]: (
    //   state,
    //   { patientProgramItem }
    // ) => {
    //   let newState = Object.assign({}, state);
    //   delete newState.patientProgramItems[patientProgramItem.id];
    //   return newState;
    // },
    [LOAD_TASKS_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingTasks: true });
    },
    [LOAD_TASKS_SUCCESS_ACTION]: (state, { tasks }) => {
      let newState = Object.assign({}, state);
      newState.tasks = {};

      return merge({}, newState, merge({}, tasks, { loadingTasks: false }));
    },
    [LOAD_TASKS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingTasks: false });
    },
    [LOAD_CONDITIONS_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingConditions: true });
    },
    [LOAD_CONDITIONS_SUCCESS_ACTION]: (state, { conditions }) => {
      let newState = Object.assign({}, state);
      newState.conditions = {};

      return merge(
        {},
        newState,
        merge({}, conditions, { loadingConditions: false })
      );
    },

    [LOAD_HISTORY_SUCCESS_ACTION]: (state, { data }) => {
      let newState = Object.assign({}, state);
      newState.versions = {};
      return merge({}, newState, data);
    },
    [IMPORT_FORM_REQUEST_ACTION]: state => {
      return merge({}, state, { importing: true });
    },
    [IMPORT_FORM_SUCCESS_ACTION]: (state, { data }) => {
      return merge({}, state, merge({}, data, { importing: false }));
    },
    [IMPORT_FORM_FAILURE_ACTION]: state => {
      return merge({}, state, { importing: false });
    },
    [LOAD_CONDITIONS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingConditions: false });
    },
    [SAVE_CONDITION_SUCCESS_ACTION]: (state, { condition }) => {
      return merge(
        {},
        state,
        merge({}, condition, { loadingConditions: false })
      );
    },

    [DELETE_CONDITION_SUCCESS_ACTION]: (state, { condition }) => {
      /* Clear out the patients for the search... */
      let newState = Object.assign({}, state);
      delete newState.conditions[condition.id];
      return newState;
    },

    // [SAVE_PATIENT_PROGRAM_ITEM_SUCCESS_ACTION]: (
    //   state,
    //   { patientProgramItem }
    // ) => {
    //   return merge(
    //     {},
    //     state,
    //     merge({}, patientProgramItem, { loadingPrograms: false })
    //   );
    // },
    [SAVE_TASK_SUCCESS_ACTION]: (state, { task }) => {
      return merge({}, state, merge({}, task, { loadingTasks: false }));
    },
    [DELETE_TASK_SUCCESS_ACTION]: (state, { task }) => {
      /* Clear out the patients for the search... */
      let newState = Object.assign({}, state);
      delete newState.tasks[task.id];
      return newState;
    },
    [DELETE_PATIENT_SUCCESS_ACTION]: (state, { patient }) => {
      let newState = Object.assign({}, state);
      delete newState.patients[patient.id];
      return newState;
    },
    [DELETE_USER_SUCCESS_ACTION]: (state, { user }) => {
      let newState = Object.assign({}, state);
      delete newState.users[user.id];
      return newState;
    },
    [DELETE_PATIENT_CONDITION_SUCCESS_ACTION]: (
      state,
      { patientCondition }
    ) => {
      let newState = Object.assign({}, state);
      delete newState.patientConditions[patientCondition.id];
      return newState;
    },
    // [DELETE_PATIENT_PROGRAM_SUCCESS_ACTION]: (state, { patientProgram }) => {
    //   let newState = Object.assign({}, state);
    //   delete newState.patientPrograms[patientProgram.id];
    //   return newState;
    // },
    [DELETE_PROGRAM_ITEM_SUCCESS_ACTION]: (state, { programItem }) => {
      let newState = Object.assign({}, state);
      delete newState.programItems[programItem.id];
      return newState;
    },
    // [DELETE_GUEST_PERMISSION_SUCCESS_ACTION]: (state, { guestPermission }) => {
    //   let newState = Object.assign({}, state);
    //   let patientCondition =
    //     newState.patientConditions[guestPermission.patientConditionId];
    //   if (
    //     patientCondition.relationships &&
    //     patientCondition.relationships.guestClinicians
    //   ) {
    //     delete patientCondition.relationships.guestClinicians.data;
    //   }
    //   return newState;
    // },

    [LOAD_ATTACHMENTS_REQUEST_ACTION]: state => {
      return merge({}, state, { loadingAttachments: true });
    },
    [LOAD_ATTACHMENTS_SUCCESS_ACTION]: (state, { attachments }) => {
      let newState = Object.assign({}, state);
      newState.attachments = {};

      return merge(
        {},
        newState,
        merge({}, attachments, { loadingAttachments: false })
      );
    },
    [LOAD_ATTACHMENTS_FAILURE_ACTION]: state => {
      return merge({}, state, { loadingAttachments: false });
    },
    [ATTACH_ATTACHMENTS_SUCCESS_ACTION]: (state, { attachments }) => {
      return merge(
        {},
        state,
        merge({}, attachments, { loadingAttachments: false })
      );
    },
    [LOGOUT_SUCCESS_ACTION]: state => {
      return { ...initialState };
    }

    // [LOAD_PATIENT_PROGRAM_REQUEST_ACTION]: state => {
    //   return merge({}, state, { loadingPrograms: true });
    // },
    // [LOAD_PATIENT_PROGRAM_SUCCESS_ACTION]: (state, { patientProgram }) => {
    //   return merge(
    //     {},
    //     state,
    //     merge({}, patientProgram, { loadingPrograms: false })
    //   );
    // },
    // [LOAD_PATIENT_PROGRAM_FAILURE_ACTION]: state => {
    //   return merge({}, state, { loadingPrograms: false });
    // }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/ducks/data.js